import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { OrderStatus, WOErrorTokens } from '../../../common/enums/enums';
import { api } from '../../../redux/rtk/api';
import { useDeclineAndApproveOrderMutation } from '../../../redux/rtk/orders.services';
import { currentUserCompanyId } from '../../../redux/selectors/userDataSelectors';
import { ApprovalsContext } from '../Approvals.provider';
import { getServicesPendingToApprove } from './useStatusByOrder';
import { getBody } from './useVehicleOrdersForApproval';

const PROP_BY_STATUS = {
  [OrderStatus.approved]: 'approvedServiceIds',
  [OrderStatus.declined]: 'declinedServiceIds',
};

export default function useApproveAndDeclineServices() {
  const { t } = useTranslation('approvals');
  const {
    pageNumber,
    searchQuery,
    servicesCheckedStatus,
    setOrderToApproveOrDecline,
    setShowSuccessSnackBar,
    setShowErrorSnackBar,
    setErrorMessage,
    orderToApproveOrDecline: order,
  } = useContext(ApprovalsContext);
  const dispatch = useDispatch();
  const compnayId = useSelector(currentUserCompanyId);
  const [_patchOrder, { isLoading }] = useDeclineAndApproveOrderMutation();

  const body = getBody(pageNumber, searchQuery, compnayId);

  const services = getServicesPendingToApprove(order)
    .filter(service => servicesCheckedStatus[service.vendorOrderServiceId])
    .reduce(
      (acc, service) => {
        const prop =
          PROP_BY_STATUS[servicesCheckedStatus[service.vendorOrderServiceId]];

        acc[prop].push(service.vendorOrderServiceId);
        return acc;
      },
      {
        [PROP_BY_STATUS[OrderStatus.approved]]: [],
        [PROP_BY_STATUS[OrderStatus.declined]]: [],
      }
    );

  const patchOrder = async observation => {
    try {
      await _patchOrder({
        ...services,
        orderId: order.orderId,
        observation,
      }).unwrap();

      dispatch(
        api.util.updateQueryData('getVehicleOrders', body, previousData => {
          const newVehicleOrders = previousData.vehicleOrders.filter(
            subOrder => subOrder.orderId !== order.orderId
          );

          previousData.vehicleOrders = newVehicleOrders;
          previousData.pagination.totalResults -= 1;
        })
      );
      setOrderToApproveOrDecline(null);
      setShowSuccessSnackBar(true);
    } catch (error) {
      if (error.data.token === WOErrorTokens.ORDER_HAS_NO_PENDING_APPROVALS) {
        setErrorMessage(t('servicesPausedErrorMessage'));
      } else {
        setErrorMessage(t('errorMessage'));
      }
      setShowErrorSnackBar(true);
    }
  };

  return { isLoading, patchOrder, services };
}
